import QueryString from 'qs';
import { remoteJSON } from './remote';
export const autocomplete = async (query:string,countryCode:string) => {
    const queryParams = {
        input:query,
        types:"address",
        components:`country:${countryCode}`
    }
	const result = (await remoteJSON(`/place/autocomplete?${QueryString.stringify(queryParams)}`, { method: 'GET' })) as {
        data:{ 
            predictions:{description: string;
                place_id: any;
            }[]
        }
}
	return result;
};

export const placeDetails = async (placeId: string) => {
	const result = (await remoteJSON(`/place/details?${QueryString.stringify({
        place_id:placeId,
        fields:"address_components,formatted_address"
    })}`, { method: 'GET' })) as {
        data:{
            result:{
                address: string;
                address_components: Array<{
                   long_name: string;
                    short_name: string;
                    types: Array<string>;
                }>
            }
        }
       }
    return result;
};